import { combineReducers } from '@reduxjs/toolkit';
import { informationReducer, InformationState } from './information/reducers';
import { allergiesReducer, AllergiesState } from './allergies/reducers';
import { conditionsReducer, ConditionsState } from './conditions/reducers';
import { medicationsReducer, MedicationsState } from './medications/reducers';
import { vitalsReducer, VitalsState } from './vitals/reducers';
import { insuranceReducer, InsuranceState } from './insurance/reducers';
import { paymentMethodReducer, PaymentMethodState } from './paymentMethod/reducers';
import { practicesReducer, PracticesState } from './practices/reducers';
import { providersReducer, ProvidersState } from './providers/reducers';
import { pharmaciesReducer, PharmaciesState } from './pharmacies/reducers';
import { specialtiesReducer, SpecialtiesState } from './specialties/reducers';
import { healthDocumentsReducer, HealthDocumentsState } from './healthDocuments/reducers';
import { SpeedPassState } from './speedPass/types';
import { speedPassReducer } from './speedPass/reducers';

export type ActiveConsumerState = {
  // Information
  information: InformationState;
  // Visit Search
  practices: PracticesState;
  providers: ProvidersState;
  specialties: SpecialtiesState;
  // Medical History
  allergies: AllergiesState;
  conditions: ConditionsState;
  medications: MedicationsState;
  vitals: VitalsState;
  healthDocuments: HealthDocumentsState;
  // Insurance
  insurance: InsuranceState;
  // Payment Method
  paymentMethod: PaymentMethodState;
  // Pharmacies
  pharmacies: PharmaciesState;
  // Speed Pass
  speedPass: SpeedPassState;
};

export const activeConsumerReducer = combineReducers({
  // Information
  information: informationReducer,
  // Visit Search
  practices: practicesReducer,
  providers: providersReducer,
  specialties: specialtiesReducer,
  // Medical History
  allergies: allergiesReducer,
  conditions: conditionsReducer,
  medications: medicationsReducer,
  vitals: vitalsReducer,
  healthDocuments: healthDocumentsReducer,
  // Insurance
  insurance: insuranceReducer,
  // Payment Method
  paymentMethod: paymentMethodReducer,
  // Pharmacies
  pharmacies: pharmaciesReducer,
  // Speed Pass
  speedPass: speedPassReducer
});
